export const styleTableEk2 = 'table {border-collapse:collapse; border:1px solid gray} th,td {border:1px solid gray}';
export const styleTableMinistry = 'table {border:none} th,th {border:none}';
